import {createGlobalStyle} from "styled-components";

export const GlobalStyle = createGlobalStyle`

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video, button, textarea {
        box-sizing: border-box;
        background: transparent;
        outline: none;
        margin: 0;
        padding: 0;
        border: 0;
        font-family: 'Sora', sans-serif;
        list-style: none;

        ::-webkit-scrollbar {
            width: 8px;          
            background: ${props => props.theme.backgrounds.gray8};
            border-radius: 100px;
            height: 8px;
        }

        ::-webkit-scrollbar-thumb{
            width: 8px;
            height: 8px;  
            background: #7A7A7A;
            border-radius: 100px;

        }
    }

    hr{
        margin: 0;
        border: none;
    }

    input{
        outline: none;
        background: transparent;
        border: none;
    }

    html, body, #root{
        height: 100%;
    }

  /* ===== FUNDO ===== */
  .MuiAutocomplete-paper {
    background-color: ${props => props.theme.backgrounds.white}!important;
    border-radius: 10px;
    margin-top: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
    color: ${props => props.theme.colors.black}!important;
  }

  /* ===== LISTA ===== */
  .MuiAutocomplete-listbox {
    padding: 4px 0;
    max-height: 260px;


  }

  /* ===== ITEM ===== */
  .MuiAutocomplete-option {
    padding: 10px 16px;
    font-size: 14px;
    color: ${props => props.theme.colors.black};
  }

  .MuiAutocomplete-option:hover {
    background-color: ${props => props.theme.backgrounds.gray7}!important;
  }

  .MuiAutocomplete-option.Mui-focused {
    background-color: ${props => props.theme.backgrounds.gray7}!important;
  }

  .MuiAutocomplete-option[aria-selected='true'] {
    color: ${props => props.theme.colors.black}!important;
  }


  /* ================= TEXTO "SEM RESULTADO" ================= */
  .MuiAutocomplete-noOptions {
    padding: 12px 16px;
    font-size: 14px;
    color: ${props => props.theme.colors.black}!important; 
    text-align: center;
  }


`;
